(function ($) {
    var windowWidth = $(window).width();

    $(document).ready(function(){
        if ( $(window).width() > 768){
            fiftyFiftyTablet();
        } else {
            fiftyFiftyMobile();
        }
    });

    $(window).resize(function() {
        if ($(window).width() > 768){
            fiftyFiftyTablet();
        } else {
            fiftyFiftyMobile();
        }
    });

    function fiftyFiftyTablet(){
        $('.band-50-50-overlap').each(function(){
            var fiftyBody = $('.overlap-body', this).height();
            var fiftyImage = $('.overlap-image', this).height();

            if (fiftyBody > fiftyImage){
                $('.overlap-wrapper', this).css({
                    "height": fiftyBody, 
                    "align-items": "center"
                });
            } else {
                $('.overlap-wrapper', this).css({
                    "height": "auto", 
                    "align-items": "center"
                });
            }
        });
    }
    function fiftyFiftyMobile(){
        $('.band-50-50-overlap').each(function(){
            $('.overlap-wrapper', this).css({
                "height": "auto", 
                "align-items": "initial"
            });
        });
    }

})(jQuery);